export const reservation: any = {
  status: {
    arranged: "Reserved",
    cancelled: "Cancelled",
    unconfirmed: "Unconfirmed",
    created: "Created",
  },
};
